// Portal Redirect Component
// Redirects /portal/:userId to the home page /portal/:userId/home
import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../services/api';

const PortalRedirect = () => {
  const { teacherId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const findHomePage = async () => {
      try {
        // Fetch pages to find the home page
        const pages = await api.get(`/pages/public/${teacherId}`);

        // Find the home page (is_home_page = true) or default to 'home' slug
        const homePage = pages.find(p => p.is_home_page) || pages.find(p => p.slug === 'home');

        if (homePage) {
          navigate(`/portal/${teacherId}/${homePage.slug}`, { replace: true });
        } else if (pages.length > 0) {
          // Fallback to first page
          navigate(`/portal/${teacherId}/${pages[0].slug}`, { replace: true });
        } else {
          // No pages exist - show message
          setLoading(false);
        }
      } catch (error) {
        console.error('Error finding home page:', error);
        setLoading(false);
      }
    };

    findHomePage();
  }, [teacherId, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#7A99D8]"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <p className="text-gray-500">No portal pages found.</p>
    </div>
  );
};

export default PortalRedirect;
